/* ===========================================================================
   Grid
   =========================================================================== */

import { hideClass } from '../settings/settings';

/**
 * Grid
 * @method show
 * @return {[type]} [description]
 */
class Grid {

  constructor(name) {
    this.name = document.getElementById('grid');
  }

  show() {
    this.name.classList.toggle(hideClass);
  }

}

const grid = new Grid();
const $buttonShowGrid = document.getElementById('button-show-grid');

if ($buttonShowGrid) {
  $buttonShowGrid.addEventListener('click', () => { grid.show(); });
}

document.addEventListener('keydown', function(e) {

  if (e.ctrlKey && e.which === 72) {
    e.preventDefault();
    grid.show();
  }

});
